import type { TOC } from '@ember/component/template-only';
import type {
  IconColor,
  IconName,
} from '@mylighthouse/prism-ember/types/components/prism/icon';
import GeneralIconWithTooltip from 'lumen/components/general/icon-with-tooltip';
import getNumberSignClass from 'lumen/helpers/get-number-sign-class';

type TooltipArgsOrNoTooltip =
  | {
      showTooltip: false;
    }
  | {
      showTooltip: true;
      tooltipIconColor: IconColor;
      tooltipIconName: IconName;
      tooltipMessage: string;
      tooltipTitle?: string;
    };

interface MarketTotalRevenueCellsTdChangeWithTooltipSignature {
  Args: {
    cellData: {
      displayValue: string;
      value: number;
    } & TooltipArgsOrNoTooltip;
    value: number | null;
  };
}

const MarketTotalRevenueCellsTdChangeWithTooltip = <template>
  <div class={{getNumberSignClass @value}}>
    <div class="flex items-center gap-100">
      {{@cellData.displayValue}}
      {{#if @cellData.showTooltip}}
        <GeneralIconWithTooltip
          @color={{@cellData.tooltipIconColor}}
          @iconName={{@cellData.tooltipIconName}}
          @size="small"
          @tooltipContent={{@cellData.tooltipMessage}}
          @tooltipTitle={{@cellData.tooltipTitle}}
        />
      {{/if}}
    </div>
  </div>
</template> satisfies TOC<MarketTotalRevenueCellsTdChangeWithTooltipSignature>;

export default MarketTotalRevenueCellsTdChangeWithTooltip;
